// extracted by mini-css-extract-plugin
module.exports = {"dark-theme":"ResendConfirmationInstructions_dark-theme_14_GR","bold":"ResendConfirmationInstructions_bold_1GNm0"};